module.exports = __webpack_public_path__ + "img/iPhone-casino.a2e7198c.webp";